export class FacePressuresGeotechData {

    constructor(calculation, data = {}) {

        this.id = data.id ?? null;
        this.uid = data.uid ?? null;
        this.calculation = calculation ?? null;
        this.objectTbm = data.objectTbm ?? null;
        this.tunnelFaceAngle = data.tunnelFaceAngle ?? null;
        this.tbmElevationTop = data.tbmElevationTop ?? null;
        this.tbmElevationBottom = data.tbmElevationBottom ?? null;
        this.tbmLevelTop = data.tbmLevelTop ?? null;
        this.tbmLevelBottom = data.tbmLevelBottom ?? null;
        this.siloElevationTop = data.siloElevationTop ?? null;
        this.siloElevationBottom = data.siloElevationBottom ?? null;
        this.siloVerticalLevelTop = data.siloVerticalLevelTop ?? null;
        this.siloVerticalLevelBottom = data.siloVerticalLevelBottom ?? null;
        this.overburden = data.overburden ?? null;
        this.slidingWedgeElevationBottom = data.slidingWedgeElevationBottom ?? null;
        this.slidingWedgeHeight = data.slidingWedgeHeight ?? null;
        this.hwCrown = data.hwCrown ?? null;
        this.unitWeightSoilGama1Average = data.unitWeightSoilGama1Average ?? null;
        this.cohesion1Average = data.cohesion1Average ?? null;
        this.internalFrictionAngle1Average = data.internalFrictionAngle1Average ?? null;
        this.unitWeightSoilGama1MinAverage = data.unitWeightSoilGama1MinAverage ?? null;
        this.unitWeightWaterGamaW1Average = data.unitWeightWaterGamaW1Average ?? null;
        this.unitWeightSoilGama2Average = data.unitWeightSoilGama2Average ?? null;
        this.cohesion2Average = data.cohesion2Average ?? null;
        this.internalFrictionAngle2Average = data.internalFrictionAngle2Average ?? null;
        this.k02Average = data.k02Average ?? null;
        this.ka2Average = data.ka2Average ?? null;
        this.k1Average = data.k1Average ?? null;
        this.k2Average = data.k2Average ?? null;
        this.unitWeightWaterGamaW2Average = data.unitWeightWaterGamaW2Average ?? null;
        this.unitWeightSoilGama2MinAverage = data.unitWeightSoilGama2MinAverage ?? null;
        this.maximumAllowableFacePressureSafetyFactor = data.maximumAllowableFacePressureSafetyFactor ?? null;

    }

    get modelSection() {
        return this.calculation?.modelSection ?? null;
    }

    get geoSection() {
        return this.modelSection?.geoSection ?? null;
    }

    get elevationOfZeroDatumLevel() {
        return this.geoSection?.elevationOfZeroDatumLevel ?? null;
    }

    get tbmAxisElevation() {
        return this.objectTbm?.axisElevation ?? null;
    }

    get tbmExcavationDiameter() {
        return this.objectTbm?.excavationDiameter ?? null;
    }

    get tbmSlope() {
        return this.objectTbm?.slope ?? null;
    }

    get k1CalcMethod() {
        return this.calculation?.k1CalcMethod ?? null;
    }

    get k2CalcMethod() {
        return this.calculation?.k2CalcMethod ?? null;
    }

    get trCalcMethod() {
        return this.calculation?.trCalcMethod ?? null;
    }

}
